import axios from 'axios'

const MENSAGEM_PADRAO = 'Erro inesperado.'

function normalizarMensagem(valor: unknown): string | null {
  if (typeof valor !== 'string') return null

  const mensagem = valor.trim()
  return mensagem.length > 0 ? mensagem : null
}

function extrairMensagemDaResposta(data: unknown): string | null {
  const mensagemTextual = normalizarMensagem(data)
  if (mensagemTextual) return mensagemTextual

  if (typeof data !== 'object' || data === null) return null

  const payload = data as Record<string, unknown>
  return normalizarMensagem(payload.message) ?? normalizarMensagem(payload.error)
}

export function resolverMensagemErro(error: unknown, fallback: string): string {
  const mensagemFallback = normalizarMensagem(fallback) ?? MENSAGEM_PADRAO

  if (axios.isAxiosError(error)) {
    if (error.response) {
      return extrairMensagemDaResposta(error.response.data) ?? mensagemFallback
    }

    return normalizarMensagem(error.message) ?? mensagemFallback
  }

  if (error instanceof Error) {
    return normalizarMensagem(error.message) ?? mensagemFallback
  }

  return mensagemFallback
}
